import React, { useState } from "react";
import DataGrid, { Editing, Column, Button } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import PropTypes from "prop-types";
import { loadMessages, formatMessage, locale } from "devextreme/localization";
import dictionary from "../../../data/dictionary";
import notify from "devextreme/ui/notify";
import { Popup } from "devextreme-react/popup";
import WebsiteServiceTitleItemDetail from "./WebsiteServiceTitleItemDetail";
import { FILE_URL, WEBSITE_URL } from "../../../utils/constants";

loadMessages(dictionary);

const parseJSON = (str, languageId) => {
  let _strObj;
  try {
    _strObj = JSON.parse(str);
  } catch (e) {
    return "";
  }
  return _strObj ? _strObj[languageId] || "" : "";
};

const ServiceTitleVM = (data, languages) => {
  const returnData = Object.assign({}, data);

  languages.forEach((element) => {
    returnData[`name-${element.languageId}`] = parseJSON(
      data.name,
      element.languageId
    );
    returnData[`description-${element.languageId}`] = parseJSON(
      data.description,
      element.languageId
    );
  });

  return returnData;
};

const WebsiteServiceTitleItemsList = ({
  serviceId,
  currentWebsite,
  currentLanguage,
  accessToken,
  languages,
  titleId,
}) => {
  locale(currentLanguage.substring(0, 2));
  const URL = `${WEBSITE_URL}Services/item/get-all/${currentWebsite}/${serviceId}/${titleId}`;
  const [showItemPopup, setShowItemPopup] = useState(false);
  const [serviceTitleItemId, setServiceTitleItemId] = useState(null);

  const loadRequest = (url) => {
    return fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": currentLanguage,
      },
    }).then((result) =>
      result.json().then((json) => {
        if (result.ok) {
          return {
            data: json.map((image) => ServiceTitleVM(image, languages)),
          };
        }
        throw json.Message;
      })
    );
  };

  const removeRequest = (url) => {
    return fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": currentLanguage,
      },
    }).then((result) => {
      if (result.ok) {
        return result.text().then((text) => {
          if (text) {
            const _response = JSON.parse(text);
            notify(
              {
                message: _response.message,
                position: {
                  my: "center top",
                  at: "center top",
                },
              },
              "success",
              3000
            );

            return _response;
          }
        });
      } else {
        return result.json().then((json) => {
          throw json.Message;
        });
      }
    });
  };

  const serviceItemsData = new CustomStore({
    key: "id",
    load: () => loadRequest(`${URL}`),
    remove: (key) => removeRequest(`${URL}/${key}`),
  });

  const imgCellRender = (data) => {
    return (
      <img
        alt="GHM Image"
        src={`${FILE_URL}/${data.value}`}
        style={{ height: 100 }}
      />
    );
  };

  const onToolbarPreparing = (e) => {
    const toolbarItems = e.toolbarOptions.items;
    // Modifies an existing item
    toolbarItems.forEach(function (item) {
      if (item.name === "addRowButton") {
        item.options = {
          icon: "plus",
          onClick: function () {
            showServiceTitleItemDetail();
          },
        };
      }
    });

    toolbarItems.push({
      location: "center",
      text: "Danh sách Service Title Items",
    });
  };

  const showServiceTitleItemDetail = (_serviceTitleItemId) => {
    setServiceTitleItemId(_serviceTitleItemId);
    setShowItemPopup(true);
  };

  const hideItemDetailPopup = () => {
    setShowItemPopup(false);
    setServiceTitleItemId(null);
  };

  return (
    <React.Fragment>
      <DataGrid
        dataSource={serviceItemsData}
        showBorders={true}
        columnAutoWidth={true}
        onToolbarPreparing={onToolbarPreparing}
      >
        <Editing
          mode="form"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
        />

        {languages.map((item, index) => (
          <Column
            key={index}
            dataField={`name-${item.languageId}`}
            dataType="string"
            caption={formatMessage("name")}
            visible={item.languageId === currentLanguage}
          ></Column>
        ))}
        {languages.map((item, index) => (
          <Column
            key={index}
            dataField={`description-${item.languageId}`}
            dataType="string"
            caption={formatMessage("description")}
            visible={item.languageId === currentLanguage}
          ></Column>
        ))}
        <Column dataField="image" cellRender={imgCellRender} />
        <Column
          dataField="alt"
          dataType="string"
          caption={formatMessage("alt")}
        />
        <Column
          dataField="order"
          dataType="number"
          caption={formatMessage("order")}
        />
        <Column
          dataField="isActive"
          dataType="boolean"
          caption={formatMessage("isActive")}
        />

        <Column type="buttons" caption={formatMessage("actionCol")}>
          <Button name="delete" />
          <Button
            hint="Info"
            icon="info"
            onClick={(e) => showServiceTitleItemDetail(e.row.key)}
          />
        </Column>
      </DataGrid>

      <Popup
        id="titleItemPopup"
        visible={showItemPopup}
        onHiding={() => setShowItemPopup(false)}
        dragEnabled={false}
        closeOnOutsideClick={true}
        showCloseButton={false}
        showTitle={false}
        container=".dx-viewport"
      >
        <WebsiteServiceTitleItemDetail
          accessToken={accessToken}
          currentLanguage={currentLanguage}
          currentWebsite={currentWebsite}
          websiteLanguages={languages}
          titleId={titleId}
          serviceId={serviceId}
          id={serviceTitleItemId}
          hidePopup={hideItemDetailPopup}
        />
      </Popup>
    </React.Fragment>
  );
};

WebsiteServiceTitleItemsList.propTypes = {
  accessToken: PropTypes.string,
  languages: PropTypes.array,
  currentLanguage: PropTypes.string,
  currentWebsite: PropTypes.string,
  items: PropTypes.array,
  serviceId: PropTypes.string,
  titleId: PropTypes.string,
};

export default WebsiteServiceTitleItemsList;
